// export const BASE_URL = "https://test.api.sadabdhrubo.me/api/"
// export const PUBLIC_URL = "https://test.api.sadabdhrubo.me/"
export const BASE_URL = "https://siteapi.rmscorpbd.com/api/"
export const PUBLIC_URL = "https://siteapi.rmscorpbd.com/"
// export const BASE_URL = "http://localhost:8000/api/" 
// export const PUBLIC_URL = "http://localhost:8000/"

